"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TypeOfContent = void 0;
var TypeOfContent;
(function (TypeOfContent) {
    TypeOfContent["Description"] = "description";
    TypeOfContent["Chart"] = "chart";
})(TypeOfContent = exports.TypeOfContent || (exports.TypeOfContent = {}));
//# sourceMappingURL=CompanyChart.js.map